import { Component, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { DefaultEditor } from 'ng2-smart-table';
import { MatButtonToggleGroup } from '@angular/material';

@Component({
  template: `
    <mat-button-toggle-group #group="matButtonToggleGroup"  style="height: 35px;">
      <mat-button-toggle
        value="{{ option }}"
        *ngFor="let option of options;"
        (click)="updateValue()"
      >
        <span>{{ option }}</span>
      </mat-button-toggle>
    </mat-button-toggle-group>`,
})
export class CustomButtonEditorComponent extends DefaultEditor implements AfterViewInit {

  @ViewChild('group', { static: false }) group: MatButtonToggleGroup;

  options = [];
  default = '';

  constructor() {
    super();

  }

  ngAfterViewInit() {

    switch (this.cell.getId()) {
      case 'repaymentFrequency': {
        this.options = [ 'Monthly', 'Fortnightly',  'Weekly'];
        this.default = this.options[0];
        break;
      }
      case 'type': {

        this.options = ['P & I', 'Interest'];
        this.default = this.options[0];
        break;
      }
      default: {
        console.log('Broken');
        break;
      }
    }

    if (this.cell.getValue() === '') {
      this.group.value = this.default;
      this.cell.setValue(this.default);
    } else {
      this.group.value = this.cell.newValue;
    }

  }

  updateValue() {
    this.cell.newValue = this.group.value;
  }

}
